import axios from 'axios'
import app from '../main'
import toast from '../error/toast'
import { langFile } from './language'

function successFunc(response) {
  switch(response.config.method) {
  case 'get':
    break;
  case 'post':
    toast.success(langFile.muvelet_sikeresen_vegrehajtva)
    break;
  case 'delete':
    toast.success(langFile.sikeres_torles)
    break;
  default:
    toast.success(langFile.muvelet_sikeresen_vegrehajtva)
  }
  return response
}

function errorFunc(error) {
  switch(error.response.status) {
  case 401:
    toast.error(langFile.nincs_jogosultsagod_a_muvelet_vegrehajtasahoz)
    break;
  default:
    toast.error(langFile.hiba_tortent_a_muvelet_vegrehajtasa_soran)
  }
}
axios.defaults.baseURL = 'https://oca.denke-plus.de/backend/api/post/'
// axios.defaults.baseURL = 'https://ocatestcenter.de/backend_customize/api/post/'
// window.axios.defaults.baseURL = (process.env.NODE_ENV !== 'production') ? 'http://localhost:9000/api/' : ''
axios.interceptors.response.use(successFunc, errorFunc);
axios.interceptors.request.use(config => {
    app.$Progress.start()
    return config;
})
axios.interceptors.response.use(response => {
    app.$Progress.finish()
    return response;
})

export let httpClient = axios.create({
  baseURL: 'https://oca.denke-plus.de/backend/api/post/'
})
